import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

const RequireAuth = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.sessionId !== null);
  const location = useLocation();

  if (!isAuthenticated) {
    // Prevent logout, login redirect to logout page loop
    let dest = location.pathname + location.search;
    if (location.pathname === '/logout') {
      dest = '/';
    }

    return <Navigate to={`/login?redirect=${encodeURIComponent(dest)}`} replace />;
  }

  return children;
};

export default RequireAuth;
